export default __webpack_public_path__ + "static/media/crackle.90f4b15b.png";